module.exports = "/images/pin-audiovideo.png?ecad883223b72fcb690ef20573718e0c";